import { render, staticRenderFns } from "./ModernSearchInput.vue?vue&type=template&id=2be8f8f3"
import script from "./ModernSearchInput.vue?vue&type=script&lang=js"
export * from "./ModernSearchInput.vue?vue&type=script&lang=js"
import style0 from "./ModernSearchInput.vue?vue&type=style&index=0&id=2be8f8f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports